export const agencyOnboarding = {
  process: {
    title: { vi: "Quy trình 3 bước trở thành Đối tác của HelloJob", bn: "হ্যালোজব জনশক্তি অংশীদার হওয়ার ৩ ধাপের প্রক্রিয়া" },
    step1: {
      title: { vi: "1. Tạo tài khoản tổ chức", bn: "১. অ্যাকাউন্ট তৈরি করুন" },
      desc: { vi: "Đăng ký tài khoản tổ chức trên nền tảng HelloJob để bắt đầu hành trình kết nối nhân lực.", bn: "জনশক্তি সংযোগ যাত্রা শুরু করতে হ্যালোজব প্ল্যাটফর্মে একটি সাংগঠনিক অ্যাকাউন্ট নিবন্ধন করুন।" }
    },
    step2: {
      title: { vi: "2. Đăng ký với Đối tác chiến lược", bn: "২. মাস্টার অংশীদারের সাথে নিবন্ধন করুন" },
      desc: { vi: "Hoàn thiện hồ sơ và đăng ký với Đối tác chiến lược - Tổng đại lý của HelloJob tại Bangladesh để được xác minh.", bn: "আপনার প্রোফাইল সম্পূর্ণ করুন এবং যাচাইকরণের জন্য বাংলাদেশে হ্যালোজব-এর মাস্টার অংশীদারের সাথে নিবন্ধন করুন।" }
    },
    step3: {
      title: { vi: "3. Trở thành Đối tác", bn: "৩. অংশীদার হন" },
      desc: { vi: "Chính thức trở thành đối tác, bắt đầu cung ứng nhân lực chất lượng cho hệ thống nhà máy, doanh nghiệp tại Việt Nam.", bn: "প্রার্থীদের পরিচয় করিয়ে দেওয়া শুরু করুন, অ্যাকাউন্ট তৈরি করুন এবং trực tiếp ভিয়েতনামের কোম্পানিগুলোর সাথে তথ্য শেয়ার করুন।" }
    }
  },
  roadmap: {
    title: { vi: "Quy trình các bước trở thành Đối tác", bn: "হ্যালোজব জনশক্তি অংশীদার হওয়ার ধাপগুলোর রোডম্যাপ" },
    desc: { vi: "Tham gia vào mạng lưới cung ứng lao động chuyên nghiệp. Chúng tôi cung cấp công cụ mạnh mẽ để bạn xây dựng thị trường và kết nối trực tiếp với doanh nghiệp Việt Nam.", bn: "পেশাদার শ্রম সরবরাহ নেটওয়ার্কে যোগ দিন। আমরা আপনাকে প্রার্থী পরিচালনা করতে এবং ভিয়েতনামি বাজারের সাথে সরাসরি সংযোগ স্থাপনের জন্য শক্তিশালী সরঞ্জাম সরবরাহ করি।" },
    registerNow: { vi: "Đăng ký ngay", bn: "এখনই নিবন্ধন করুন" },
    registered: { vi: "Đã đăng ký", bn: "নিবন্ধিত" },
    pending: { vi: "Hồ sơ chờ duyệt", bn: "অনুমোদনের অপেক্ষায় থাকা প্রোফাইল" },
    consultation: { vi: "Liên hệ Đối tác chiến lược", bn: "অংশীদারের সাথে যোগাযোগ" }
  },
  partners: {
    title: { vi: "Hệ thống doanh nghiệp tiếp nhận tại Việt Nam", bn: "ভিয়েতনামে বিশ্বস্ত নিয়োগকারী অংশীদাররা" },
    desc: { vi: "Hàng nghìn nhà máy, xí nghiệp hàng đầu tại Việt Nam sẵn sàng đón nhận nguồn nhân lực chất lượng từ Bangladesh thông qua hệ thống Đối tác.", bn: "ভিয়েতনামের শীর্ষস্থানীয় উদ্যোগগুলোর সিস্টেম বাংলাদেশ থেকে মানসম্মত জনশক্তি গ্রহণ করতে প্রস্তুত।" }
  },
  benefits: {
    title: { vi: "Quyền lợi & Công cụ cho Đối tác", bn: "অংশীদারদের জন্য সুবিধা এবং সরঞ্জাম" },
    desc: { vi: "Nâng cao hiệu quả xây dựng hệ thống khách hàng và năng lực cạnh tranh cho doanh nghiệp của bạn.", bn: "বাংলাদেশে আপনার ব্যবসার ব্যবস্থাপনা দক্ষতা এবং প্রতিযোগিতা সক্ষমতা বৃদ্ধি করুন।" },
    items: {
      intro: {
        category: { vi: "Quyền lợi", bn: "সুবিধা" },
        title: { vi: "Giới thiệu ứng viên", bn: "প্রার্থী পরিচয় করিয়ে দিন" },
        desc: { vi: "Đăng ký thông tin người lao động Bangladesh được đào tạo bài bản, phù hợp với tiêu chuẩn làm việc tại Việt Nam.", bn: "সহজে বাংলাদেশে কর্মীদের thông tin নিবন্ধন করুন যারা ভিয়েতনামে যেতে চান।" }
      },
      mgmt: {
        category: { vi: "Công cụ", bn: "সরঞ্জাম" },
        title: { vi: "Quản lý tài khoản", bn: "অ্যাকাউন্ট ব্যবস্থাপনা" },
        desc: { vi: "Tự động tạo tài khoản riêng cho từng ứng viên để họ tự cập nhật hồ sơ.", bn: "প্রতিটি প্রার্থীর জন্য স্বয়ংক্রিয়ভাবে আলাদা অ্যাকাউন্ট তৈরি করুন যাতে তারা নিজেরাই তাদের প্রোফাইল আপডেট করতে পারে।" }
      },
      share: {
        category: { vi: "Kết nối", bn: "সংযোগ" },
        title: { vi: "Kết nối nhà máy Việt Nam", bn: "সরাসরি শেয়ার করুন" },
        desc: { vi: "Hồ sơ ứng viên được chia sẻ trực tiếp tới hệ thống khách hàng doanh nghiệp, nhà máy tuyển dụng tại Việt Nam.", bn: "প্রার্থীর প্রোফাইল সরাসরি ভিয়েতনামের গ্রহণকারী কোম্পানিগুলোর সিস্টেমে শেয়ার করা হয়।" }
      },
      track: {
        category: { vi: "Minh bạch", bn: "স্বच्छতা" },
        title: { vi: "Theo dõi tiến độ", bn: "অগ্রগতি ট্র্যাক করুন" },
        desc: { vi: "Theo dõi trạng thái của từng hồ sơ ứng viên trong thời gian thực.", bn: "রিয়েল-টাইমে প্রতিটি প্রার্থীর প্রোফাইলের स्थিতি ট্র্যাক করুন।" }
      }
    },
    learnMore: { vi: "Tìm hiểu thêm", bn: "আরও জানুন" }
  },
  cta: {
    title: { vi: "Sẵn sàng để phát triển hệ thống khách hàng Việt Nam?", bn: "বাংলাদেশে কর্মী ভিয়েতনামে পাঠাতে প্রস্তুত?" },
    desc: { vi: "Hợp tác cùng HelloJob để tối ưu hóa quy trình cung ứng và nâng cao uy tín trong việc tuyển chọn lao động chuẩn pháp luật hai nước.", bn: "আপনার ব্যবসার প্রেষণ প্রক্রিয়া অপ্টিমাইজ করতে এবং সুনাম বাড়াতে হ্যালোজবের সাথে সহযোগিতা করুন।" },
    manageJobs: { vi: "Quản lý việc làm", bn: "চাকরি ব্যবস্থাপনা" },
    manageCandidates: { vi: "Quản lý ứng viên", bn: "প্রার্থী ব্যবস্থাপনা" }
  },
  roadmapPage: {
    hero: {
      badge: { vi: "Cơ hội hợp tác {year}", bn: "সহযোগিতার সুযোগ {year}" },
      title: { vi: "Đồng hành cùng HelloJob", bn: "হ্যালোজব-এর সাথে চলুন" },
      highlight: { vi: "Khai phá", bn: "উন্মোচন করুন" },
      titleSuffix: { vi: " hệ thống khách hàng", bn: " শ্রমবাজার" },
      subtitle: { vi: "Giải pháp công nghệ hàng đầu giúp Đối tác xây dựng hệ thống khách hàng doanh nghiệp Việt Nam một cách minh bạch và hiệu quả.", bn: "অঞ্চলটির সবচেয়ে স্বচ্ছ, পেশাদার এবং কার্যকর ডিজিটাল প্রক্রিয়ার মাধ্যমে বাংলাদেশি জনশক্তিকে সংযুক্ত করার শীর্ষস্থানীয় প্রযুক্তি সমাধান।" },
      ctaStart: { vi: "Bắt đầu Đăng ký ngay", bn: "এখনই নিবন্ধন শুরু করুন" },
      ctaProcess: { vi: "Tìm hiểu quy trình", bn: "প্রক্রিয়াটি সম্পর্কে জানুন" },
      dashboard: { vi: "Vào Dashboard Đối tác", bn: "পার্টনার ড্যাশবোর্ডে প্রবেশ করুন" },
      manageCandidates: { vi: "Quản lý Ứng viên", bn: "প্রার্থী ব্যবস্থাপনা" },
      pendingStatus: { vi: "Hồ sơ đang chờ duyệt", bn: "প্রোফাইল অনুমোদনের অপেক্ষায়" },
      registerNowLong: { vi: "Đăng ký ngay bây giờ", bn: "এখনই নিবন্ধন করুন" },
      backHome: { vi: "Về trang chủ", bn: "হোমপেজে ফিরে যান" }
    },
    painPoints: {
      title: { vi: "Thực trạng thị trường Bangladesh", bn: "বাংলাদেশি বাজারের বাস্তবতা" },
      subtitle: { vi: "Những rào cản ngăn bước sự phát triển của các đại lý cung ứng", bn: "সরবরাহকারী এজেন্টদের উন্নয়নে বাধা সৃষ্টিকারী প্রতিবন্ধকতাগুলো" },
      item1: {
        title: { vi: "Thiếu nguồn cung chất lượng", bn: "মানসম্মত প্রার্থীর অভাব" },
        desc: { vi: "Khó khăn trong việc tuyển chọn và cung ứng nguồn lao động có tay nghề, kinh nghiệm và tính kỷ luật cao.", bn: "দক্ষ, অভিজ্ঞ এবং উচ্চ শৃঙ্খলাপরায়ণ জনশক্তি খুঁজে পেতে এবং সরবরাহ করতে অসুবিধা।" }
      },
      item2: {
        title: { vi: "Quy trình chậm chạp", bn: "ধীরগতির প্রক্রিয়া" },
        desc: { vi: "Hồ sơ giấy tờ xử lý thủ công, mất nhiều thời gian chờ đợi phản hồi từ phía Việt Nam.", bn: "ম্যানুয়াল নথি প্রক্রিয়াকরণ, ভিয়েতনাম থেকে প্রতিক্রিয়ার জন্য দীর্ঘ সময় অপেক্ষা করতে হয়।" }
      },
      item3: {
        title: { vi: "Thiếu minh bạch", bn: "স্বच्छতার অভাব" },
        desc: { vi: "Không biết trạng thái hồ sơ ứng viên đang ở bước nào, dẫn đến mất uy tín với người lao động.", bn: "প্রার্থীর প্রোফাইলের स्थিতি কোন ধাপে আছে তা জানা যায় না, যার ফলে কর্মীদের কাছে বিশ্বাসযোগ্যতা নষ্ট হয়।" }
      },
      item4: {
        title: { vi: "Chi phí trung gian cao", bn: "উচ্চ মধ্যস্থতা খরচ" },
        desc: { vi: "Phải qua nhiều cấp môi giới khiến lợi nhuận của đại lý bị bào mòn đáng kể.", bn: "অনেক স্তরের দالاলের মাধ্যমে যেতে হয়, যা এজেন্টের মুনাফা উল্লেখযোগ্যভাবে কমিয়ে দেয়।" }
      }
    },
    solutions: {
      title: { vi: "Giải pháp từ HelloJob", bn: "হ্যালোজব থেকে সমাধান" },
      subtitle: { vi: "Chúng tôi số hóa quy trình và mở ra cơ hội kết nối chưa từng có cho đối tác.", bn: "আমরা প্রক্রিয়াটি ডিজিটাল করি এবং অংশীদারদের জন্য অভূতপূর্ব সংযোগের সুযোগ উন্মোচন করি।" },
      item1: {
        title: { vi: "Kết nối trực tiếp 100%", bn: "১০০% সরাসরি সংযোগ" },
        desc: { vi: "Làm việc trực tiếp với hệ thống tập đoàn lớn nhất Việt Nam, không qua trung gian.", bn: "ভিয়েতনামের বৃহত্তম কর্পোরেট সিস্টেম의 সাথে সরাসরি কাজ করুন, কোনো মধ্যস্থতাকারী নেই।" }
      },
      item2: {
        title: { vi: "Quản lý số hóa toàn diện", bn: "ব্যাপক ডিজিটাল ব্যবস্থাপনা" },
        desc: { vi: "Hệ thống quản lý ứng viên thông minh, tự động hóa 80% quy trình giấy tờ hồ sơ.", bn: "স্মার্ট প্রার্থী ব্যবস্থাপনা সিস্টেম, নথি প্রক্রিয়ার ৮০% স্বয়ংক্রিয়।" }
      },
      item3: {
        title: { vi: "Theo dõi Thời gian thực", bn: "রিয়েল-টাইম ট্র্যাকিং" },
        desc: { vi: "Dashboard cập nhật trạng thái hồ sơ từng giây, minh bạch tuyệt đối giữa các bên.", bn: "ড্যাশবোর্ড প্রতি সেকেন্ডে প্রোফাইলের স্থিতি আপডেট করে, পক্ষগুলোর মধ্যে পূর্ণ স্বচ্ছতা।" }
      },
      item4: {
        title: { vi: "Hỗ trợ từ Đối tác chiến lược - Tổng đại lý", bn: "মাস্টার অংশীদারের সহায়তা" },
        desc: { vi: "Được hỗ trợ 24/7 bởi Đối tác chiến lược - Tổng đại lý chính thức của HelloJob tại Dhaka.", bn: "ঢাকায় হ্যালোজব-এর অফিসিয়াল মাস্টার অংশীদারের দ্বারা ২৪/৭ সহায়তা পান।" }
      },
      cta: { vi: "Nhận giải pháp ngay", bn: "এখনই সমাধান পান" }
    },
    steps: {
      title: { vi: "Quy trình 3 bước thành công", bn: "সাফল্যের ৩ ধাপের রোডম্যাপ" },
      subtitle: { vi: "Hệ thống hóa quy trình, tối đa hóa kết quả.", bn: "প্রক্রিয়াটিকে সিস্টেমাইজ করুন, ফলাফলকে সর্বোচ্চ করুন।" },
      step1: {
        title: { vi: "Tạo tài khoản tổ chức", bn: "সাংগঠনিক অ্যাকাউন্ট তৈরি করুন" },
        desc: { vi: "Khởi tạo định danh đại lý trên HelloJob. Đây là cửa ngõ để bạn truy cập vào mạng lưới nhà tuyển dụng hàng đầu Việt Nam.", bn: "হ্যালোজব-এ এজেন্টের পরিচয় তৈরি করুন। এটি ভিয়েতনামের শীর্ষস্থানীয় নিয়োগকারী নেটওয়ার্কে আপনার প্রবেশের পথ।" },
        bullet1: { vi: "Điền thông tin cơ bản về pháp nhân doanh nghiệp", bn: "ব্যবসার মৌলিক আইনি তথ্য পূরণ করুন" },
        bullet2: { vi: "Xác thực thông tin liên hệ và người đại diện", bn: "যোগাযোগ এবং প্রতিনিধিদের তথ্য যাচাই করুন" },
        bullet3: { vi: "Thiết lập phân quyền nhân sự quản lý trực tiếp", bn: "সরাসরি ব্যবস্থাপনা কর্মীদের জন্য অনুমতি সেট আপ করুন" },
        cta: { vi: "Bắt đầu ngay", bn: "এখনই शुरू করুন" }
      },
      step2: {
        title: { vi: "Đăng ký với Đối tác chiến lược", bn: "মাস্টার অংশীদারের সাথে নিবন্ধন করুন" },
        desc: { vi: "Xác thực năng lực và pháp lý với Đối tác chiến lược - Tổng đại lý của chúng tôi. Việc này đảm bảo uy tín tuyệt đối cho hồ sơ của đại lý.", bn: "আমাদের কৌশলগত অংশীদার - মাস্টার এজেন্টের সাথে আপনার সক্ষমতা এবং আইনি বৈধতা যাচাই করুন। এটি এজেন্টের প্রোফাইলের জন্য পূর্ণ বিশ্বাসযোগ্যতা নিশ্চিত করে।" },
        bullet1: { vi: "Cung cấp giấy phép hợp lệ (nếu có)", bn: "বৈধ্য লাইসেন্স প্রদান করুন (যদি থাকে)" },
        bullet2: { vi: "Hoàn thiện hồ sơ năng lực cung ứng lao động", bn: "জনশক্তি সরবরাহের সক্ষমতার প্রোফাইল সম্পন্ন করুন" },
        bullet3: { vi: "Nhận phê duyệt định danh từ Đối tác chiến lược - Tổng đại lý", bn: "মাস্টার এজেন্টের কাছ থেকে আইডেন্টিটি অনুমোদন পান" },
        cta: { vi: "Đăng ký xác thực", bn: "যাচাইকরণের জন্য নিবন্ধন করুন" }
      },
      step3: {
        title: { vi: "Trở thành Đối tác", bn: "কৌশলगत অংশীদার হন" },
        desc: { vi: "Tiếp cận thị trường Việt Nam một cách toàn diện. Bắt đầu phái cử lao động và quản lý hợp đồng trên quy mô lớn một cách dễ dàng.", bn: "ভিয়েতনামের বাজারে ব্যাপকভাবে প্রবেশ করুন। কর্মী পাঠানো শুরু করুন এবং দাপ্তরিকভাবে চুক্তিগুলো পরিচালনা করুন।" },
        bullet1: { vi: "Đăng tải và quảng bá hồ sơ ứng viên", bn: "প্রার্থীর প্রোফাইল আপলোড এবং প্রচার করুন" },
        bullet2: { vi: "Nhận yêu cầu tuyển dụng trực tiếp từ đối tác", bn: "অংশীদারদের কাছ từ trực tiếp নিয়োগের অনুরোধ পান" },
        bullet3: { vi: "Theo dõi quá trình xuất cảnh thời gian thực", bn: "রিয়েল-টাইমে প্রস্থান প্রক্রিয়া ট্র্যাক করুন" },
        cta: { vi: "Vào Dashboard Công việc", bn: "কাজের ড্যাশবোর্ডে প্রবেশ করুন" }
      }
    },
    finalCta: {
      titlePrefix: { vi: "Sẵn sàng để đột phá", bn: "সাফল্যের জন্য প্রস্তুত" },
      titleSuffix: { vi: "kinh doanh cùng HelloJob?", bn: "হ্যালোজব-এর সাথে ব্যবসা করবেন?" },
      desc: { vi: "Đừng để quy trình cũ cản trở tương lai. Gia nhập hệ sinh thái cung ứng lao động lớn nhất Bangladesh ngay hôm nay.", bn: "পুরানো প্রক্রিয়াকে আপনার ভবিষ্যতের পথে বাধা হতে দেবেন না। আজই বাংলাদেশের বৃহত্তম জনশক্তি সরবরাহ ইকোসিস্টেমে যোগ দিন।" },
      footer: { vi: "Hàng trăm đối tác đã sẵn sàng số hóa cùng chúng tôi", bn: "শত শত অংশীদার আমাদের সাথে ডিজিটাল হতে প্রস্তুত" }
    }
  },
  onboarding: {
    pending: {
      title: { vi: "Hồ sơ đang được thẩm định", bn: "প্রোফাইল যাচাই করা হচ্ছে" },
      desc: { vi: "Cảm ơn bạn đã gửi thông tin pháp nhân. Đối tác chiến lược - Tổng đại lý của HelloJob đang tiến hành xác minh Giấy phép RL và năng lực phân phối của công ty bạn.", bn: "আপনার আইনি তথ্য পাঠানোর জন্য ধন্যবাদ। হ্যালোজব-এর কৌশলগত অংশীদার - মাস্টার এজেন্ট বর্তমানে আপনার আরএল (RL) লাইসেন্স এবং সরবরাহ সক্ষমতা যাচাই করছে।" },
      step1: {
        title: { vi: "Xác minh RL", bn: "RL যাচাইকরণ" },
        desc: { vi: "Kiểm tra tính hợp lệ của giấy phép tuyển dụng", bn: "নিয়োগ লাইসেন্সের বৈধতা পরীক্ষা করা হচ্ছে" }
      },
      step2: {
        title: { vi: "Đánh giá năng lực", bn: "সক্ষমতা মূল্যায়ন" },
        desc: { vi: "Phân tích khả năng cung ứng lao động hàng tháng", bn: "মাসিক শ্রম সরবরাহ ক্ষমতা বিশ্লেষণ করা হচ্ছে" }
      },
      step3: {
        title: { vi: "Phê duyệt hồ sơ", bn: "প্রোফাইল অনুমোদন" },
        desc: { vi: "Cấp quyền đối tác chính thức cho lãnh đạo", bn: "অফিসিয়াল পার্টনারশিপের অনুমতি প্রদান" }
      },
      buttons: {
        edit: { vi: "Sửa lại thông tin", bn: "তথ্য সংশোধন" },
        logout: { vi: "Đăng xuất", bn: "লগআউট" },
        contact: { vi: "Liên hệ hỗ trợ duyệt", bn: "অনুমোদনের জন্য সহায়তা" }
      },
      footer: { vi: "Thời gian thẩm định dự kiến: 24h - 48h làm việc.", bn: "আনুমানিক যাচাইকরণের সময়: ২৪ - ৪৮ কর্মঘণ্টা।" }
    }
  },
  registrationForm: {
    validation: {
      englishOnly: { vi: "Mục này chỉ cho nhập ký tự tiếng Anh không dấu", bn: "এই ক্ষেত্রটি শুধুমাত্র ইংরেজি বর্ণমালায় পূরণ করুন" },
      confirmTitle: { vi: "Phát hiện ký tự không hợp lệ", bn: "অকার্যকর অক্ষর সনাক্ত করা হয়েছে" },
      confirmDesc: { vi: "Có thông tin không hợp lệ bằng tiếng Anh không dấu. Bạn có muốn xem lại và sửa lỗi không?", bn: "কিছু thông tin ইংরেজি বর্ণমালায় নেই। আপনি কি এগুলো সংশোধন করতে চান?" },
      correctNow: { vi: "Đồng ý sửa", bn: "সংশোধন করুন" },
      cancel: { vi: "Hủy", bn: "বাতিল" }
    },
    header: {
      title: { vi: "Đăng ký Đối tác Cung ứng Nhân lực", bn: "জনশক্তি সরবরাহ অংশীদার হিসেবে নিবন্ধন করুন" },
      desc: { vi: "Vui lòng hoàn thành hồ sơ pháp lý và năng lực để được Đối tác chiến lược phê duyệt quyền quản trị trên hệ thống HelloJob.", bn: "হ্যালোজব বাংলাদেশ সিস্টেমে প্রশাসনিক ক্ষমতা বা অনুমোদনের জন্য অনুগ্রহ করে আপনার আইনি এবং সক্ষমতা প্রোফাইলটি সম্পন্ন করুন।" }
    },
    steps: {
      company: { vi: "Hồ sơ Công ty", bn: "কোম্পানি প্রোফাইল" },
      contact: { vi: "Liên hệ & Đại diện", bn: "যোগাযোগ ও প্রতিনিধি" },
      capacity: { vi: "Năng lực & Tài liệu", bn: "সক্ষমতা এবং নথি" }
    },
    labels: {
      companyName: { vi: "Tên pháp nhân công ty", bn: "কোম্পানির আইনি নাম" },
      rlNumber: { vi: "Mã số thuế / Giấy phép kinh doanh", bn: "নিয়োগ லைসেন্স (RL) নম্বর" },
      establishedYear: { vi: "Năm thành lập", bn: "প্রতিষ্ঠার বছর" },
      tradeLicense: { vi: "Mã số doanh nghiệp", bn: "ট্রেড লাইসেন্স নম্বর" },
      officeAddress: { vi: "Địa chỉ văn phòng tại Bangladesh", bn: "বাংলাদেশে প্রধান কার্যালয়ের ঠিকানা" },
      officialEmail: { vi: "Email chính thức công ty", bn: "কোম্পানির অফিসিয়াল ইমেইল" },
      officialPhone: { vi: "Số điện thoại Hotline", bn: "হটলাইন ফোন নম্বর" },
      managingDirector: { vi: "Họ tên Giám đốc (MD/CEO)", bn: "ব্যবস্থাপনা পরিচালকের নাম (MD/CEO)" },
      mdPhone: { vi: "SĐT Giám đốc", bn: "ব্যবস্থাপনা পরিচালকের ফোন নম্বর" },
      supplyCapacity: { vi: "Khả năng cung ứng (Người/tháng)", bn: "সরবরাহ সক্ষমতা (জন/মাস)" },
      mainIndustries: { vi: "Ngành nghề thế mạnh", bn: "প্রধান শক্তিশালী খাতগুলো" },
      rlLicensePhoto: { vi: "Ảnh giấy phép các loại", bn: "বিএমইটি লাইসেন্স এবং অন্যান্য লাইসেন্স" },
      officePhoto: { vi: "Ảnh Văn phòng thực tế", bn: "বাস্তব অফিস বা কার্যালয়ের ছবি" },
      whatsapp: { vi: "Số WhatsApp", bn: "হোয়াটসঅ্যাপ নম্বর" },
      zalo: { vi: "Số Zalo", bn: "জালো নম্বর" },
      facebook: { vi: "Link Facebook", bn: "ফেসবুক প্রোফাইল লিংক" },
      line: { vi: "ID Line", bn: "লাইন আইডি" },
      otherIndustry: { vi: "Ngành nghề khác (tự nhập)", bn: "অন্যান্য শিল্প (স্বয়ংক্রিয়ভাবে লিখুন)" },
      companyLogo: { vi: "Logo Công ty", bn: "কোম্পানির লোগো" },
      representativePhoto: { vi: "Ảnh người đại diện", bn: "ব্যবস্থাপনা পরিচালকের ছবি" },
      representativeTitle: { vi: "Chức danh đại diện", bn: "প্রতিনিধির পদবী" },
      representativeBio: { vi: "Giới thiệu ngắn / Slogan", bn: "ছোট ভূমিকা / স্লোগান" },
      sharePage: { vi: "Chia sẻ trang", bn: "পেজ শেয়ার করুন" },
      actualImages: { vi: "Bộ sưu tập ảnh thực tế (Tối đa 6 ảnh)", bn: "বাস্তব ছবির সংগ্রহ (সর্বোচ্চ ৬টি ছবি)" },
      squareRequired: { vi: "(Yêu cầu ảnh vuông 1:1)", bn: "(বর্গাকার ছবি প্রয়োজন ১:১)" }
    },
    placeholders: {
      companyName: { vi: "VD: Công ty CP Cung ứng Nhân lực ABC", bn: "উদা: বাংলাদেশ ম্যানপাওয়ার সার্ভিসেস লিমিটেড।" },
      rlNumber: { vi: "VD: 010123... hoặc số giấy phép", bn: "উদা: RL-1234" },
      establishedYear: { vi: "2010", bn: "২০১০" },
      tradeLicense: { vi: "Trade License ID", bn: "ট্রেড লাইসেন্স আইডি" },
      officeAddress: { vi: "VD: Paltan, Dhaka, Bangladesh", bn: "পল্টন, ঢাকা, বাংলাদেশ" },
      officialEmail: { vi: "info@company.com", bn: "info@company.com" },
      officialPhone: { vi: "09x...", bn: "+৮৮০..." },
      managingDirector: { vi: "Người đại diện pháp luật", bn: "ব্যবস্থাপনা পরিচালক (MD)" },
      mdPhone: { vi: "SĐT người đại diện", bn: "এমডি'র phone নম্বর" },
      selectLevel: { vi: "Chọn mức cung ứng", bn: "স্তর নির্বাচন করুন" },
      rlLicensePhoto: { vi: "Ảnh giấy phép các loại", bn: "নিয়োগ লাইসেন্সের (RL) ছবি" },
      uploadRL: { vi: "Tải lên ảnh chụp rõ nét các loại giấy phép", bn: "নিয়োগ লাইসেন্সের rõ ছবি আপলোড করুন" },
      uploadOffice: { vi: "Tải lên ảnh chụp bảng biển/văn phòng", bn: "বাস্তব অফিস বা কার্যালয়ের ছবি" },
      socialPlaceholder: { vi: "VD: +880...", bn: "উদা: +৮৮০..." },
      facebookPlaceholder: { vi: "Link Facebook cá nhân/công ty", bn: "ব্যক্তিগত বা কোম্পানির ফেসবুক লিংক" },
      uploadLogo: { vi: "Tải lên Logo (Tỉ lệ 1:1, <1MB)", bn: "লোগো আপলোড করুন (অনুপাত ১:১, <১এমবি)" },
      uploadAvatar: { vi: "Tải lên ảnh chân dung chuyên nghiệp", bn: "পেশাদার পোর্ট্রেট ছবি আপলোড করুন" },
      uploadGallery: { vi: "Thêm ảnh thực tế", bn: "বাস্তব ছবি যোগ করুন" },
      dragToSort: { vi: "Kéo thả để sắp xếp thứ tự", bn: "ক্রম পরিবর্তন করতে ড্র্যাগ এবং ড্রপ করুন" },
      representativeTitle: { vi: "VD: Giám đốc / Trưởng phòng", bn: "উদা: ব্যবস্থাপনা পরিচালক" },
      representativeBio: { vi: "VD: Chúng tôi cam kết cung cấp nguồn lao động chất lượng cao từ Việt Nam...", bn: "উদা: আমরা সেরা মানের জনশক্তি প্রদানের জন্য প্রতিশ্রুতিবদ্ধ..." },
      processing: { vi: "Đang xử lý...", bn: "প্রক্রিয়াকরণ করা হচ্ছে..." },
      avatarAdvice: { vi: "Khuyên dùng ảnh chân dung nền trắng hoặc xanh.", bn: "সাদা বা নীল ব্যাকগ্রাউন্ডের একটি প্রতিকৃতি ছবি সুপারিশ করা হয়।" },
      zaloId: { vi: "SĐT / ID", bn: "ফোন / আইডি" },
      lineId: { vi: "VD: line-id...", bn: "উদা: লাইন-আইডি..." },
      selectedCount: { vi: "đã chọn", bn: "নির্বাচিত" },
      searchIndustries: { vi: "Tìm kiếm ngành nghề...", bn: "শিল্প অনুসন্ধান করুন..." },
      showLess: { vi: "Thu gọn -", bn: "কম দেখান -" },
      showMore: { vi: "Xem thêm +", bn: "আরো দেখুন +" },
      otherIndustryDetail: { vi: "Chi tiết ngành nghề khác", bn: "অন্যান্য শিল্পের বিবরণ" },
      documentSelected: { vi: "Đã chọn tài liệu", bn: "নথি নির্বাচন করা হয়েছে" },
      uploading: { vi: "Đang tải lên...", bn: "আপলোড করা হচ্ছে..." },
      squareLabel: { vi: "Bản vuông (1:1)", bn: "বর্গাকার (১:১)" },
      progress: { vi: "Tiến độ", bn: "অগ্রগতি" },
      logoResolutionAdvice: { vi: "Cần Logo độ phân giải tốt để in lên Poster giới thiệu.", bn: "পরিচয়মূলক পোস্টারে মুদ্রণের জন্য উচ্চ রেজোলিউশনের লোগো প্রয়োজন।" },
      primary: { vi: "Chính", bn: "প্রাথমিক" },
      loading: { vi: "Đang tải...", bn: "লোড হচ্ছে..." },
      preview: { vi: "Xem trước", bn: "প্রাকদর্শন" }
    },
    capacityOptions: {
      under50: { vi: "Dưới 50 người", bn: "৫০ জনের কম" },
      range50_100: { vi: "Từ 50 - 100 người", bn: "৫০ - ১০০ জন" },
      range100_200: { vi: "Từ 100 - 200 người", bn: "১০০ - ২০০ জন" },
      over200: { vi: "Trên 200 người", bn: "২০০ জনের বেশি" }
    },
    industries: {
      construction: { vi: "Xây dựng", bn: "নির্মাণ" },
      manufacturing: { vi: "Sản xuất", bn: "উৎপাদন" },
      agriculture: { vi: "Nông nghiệp", bn: "কৃষি" },
      hotel: { vi: "Khách sạn", bn: "হোটেল" },
      garment: { vi: "May mặc", bn: "গার্মেন্টস" },
      other: { vi: "Khác", bn: "অন্যান্য" }
    },
    buttons: {
      back: { vi: "Quay lại", bn: "পিছনে" },
      cancel: { vi: "Hủy chỉnh sửa", bn: "সম্পাদনা বাতিল" },
      next: { vi: "Tiếp theo", bn: "পরবর্তী" },
      submit: { vi: "Gửi hồ sơ phê duyệt", bn: "অনুমোদনের জন্য আবেদন জমা দিন" }
    },
    toasts: {
      success: {
        title: { vi: "Gửi hồ sơ thành công!", bn: "আবেদন সফলভাবে জমা হয়েছে!" },
        desc: { vi: "Hồ sơ của bạn đang được Tổng đại lý xem xét phê duyệt.", bn: "আপনার প্রোফাইল বর্তমানে মাস্টার এজেন্ট দ্বারা যাচাই করা হচ্ছে।" }
      },
      copied: {
        title: { vi: "Đã sao chép!", bn: "কপি করা হয়েছে!" },
        desc: { vi: "Liên kết đã được lưu vào bộ nhớ tạm.", bn: "লিঙ্কটি ক্লিপবোর্ডে সেভ করা হয়েছে।" }
      },
      error: {
        title: { vi: "Lỗi gửi hồ sơ", bn: "আবেদন জমা দিতে ত্রুটি" },
        desc: { vi: "Vui lòng thử lại sau.", bn: "অনুগ্রহ করে পরে আবার চেষ্টা করুন।" },
        maxImages: { vi: "Chỉ được tải lên tối đa 6 ảnh thực tế", bn: "আপনি সর্বোচ্চ ৬টি বাস্তব ছবি আপলোড করতে পারবেন" }
      }
    },
    privacy: { vi: "Thông tin đăng ký sẽ được bảo mật theo tiêu chuẩn quốc tế và chỉ phục vụ mục đích xác thực đối tác bởi Tổng đại lý HelloJob. Sau khi được duyệt, bạn sẽ có quyền truy cập hệ thống.", bn: "নিবন্ধনের তথ্য আন্তর্জাতিক মান অনুযায়ী গোপন রাখা হবে এবং শুধুমাত্র হ্যালোজব মাস্টার এজেন্ট দ্বারা অংশীদার যাচাইকরণের জন্য ব্যবহৃত হবে। অনুমোদিত হওয়ার পরে, আপনি সিস্টেমে অ্যাক্সেস পাবেন।" }
  }
};
